import Vue from 'vue'
import ElementUI from 'element-ui'


// WEBPACK FOOTER //
// ./vue/vendor.js